import React from 'react';
import { motion } from 'framer-motion';

const assets = [
  { type: 'video', url: 'https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0508%20(1).mov/ik-video.mp4?updatedAt=1781381093797' },
  { type: 'video', url: 'https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0520(5).mov/ik-video.mp4?updatedAt=1781381286449' },
  { type: 'image', url: 'https://ik.imagekit.io/aeu02xvjgn/Updated%20images/ChatGPT%20Image%20May%202,%202026,%2007_32_58%20PM.png?updatedAt=1777937948311' },
  { type: 'image', url: 'https://ik.imagekit.io/aeu02xvjgn/Updated%20images/ChatGPT%20Image%20May%202,%202026,%2007_34_30%20PM.png?updatedAt=1777937947742' },
  { type: 'video', url: 'https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0606%20(1).mov/ik-video.mp4?updatedAt=1781380963578' }
];

const ExperienceSection = () => {
  return (
    <section className="py-24 bg-padua-cream/40">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-16">
          <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
            <h2 className="text-3xl md:text-5xl font-serif text-padua-charcoal mb-6">A Wedding Venue That Feels Like a Hidden Estate</h2>
            <p className="text-lg md:text-xl text-padua-charcoal/80 leading-relaxed font-light">
              Couples love the architecture, the views, and the intimate atmosphere that feels timeless before any decor is added.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 h-auto md:h-[1000px]">
          <motion.div initial={{ opacity: 0, scale: 0.98 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} className="md:col-span-8 md:row-span-2 rounded-2xl overflow-hidden shadow-2xl bg-padua-charcoal border border-padua-gold/10">
            <video autoPlay muted loop playsInline className="w-full h-full object-cover opacity-90" src={assets[0].url} />
          </motion.div>
          
          <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="md:col-span-4 md:row-span-1 rounded-2xl overflow-hidden shadow-xl bg-padua-charcoal border border-padua-gold/10">
            <video autoPlay muted loop playsInline className="w-full h-full object-cover opacity-90" src={assets[1].url} />
          </motion.div>
          
          <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="md:col-span-4 md:row-span-1 rounded-2xl overflow-hidden shadow-xl border border-padua-gold/10">
            <img src={assets[2].url} alt="Estate" className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000" />
          </motion.div>
          
          <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="md:col-span-4 md:row-span-1 rounded-2xl overflow-hidden shadow-xl border border-padua-gold/10 h-64 md:h-auto">
            <img src={assets[3].url} alt="Ceremony" className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000" />
          </motion.div>

          <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="md:col-span-8 md:row-span-1 rounded-2xl overflow-hidden shadow-xl bg-padua-charcoal border border-padua-gold/10 h-64 md:h-auto">
            <video autoPlay muted loop playsInline className="w-full h-full object-cover opacity-90" src={assets[4].url} />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;